<template>
  <v-layout>
    <v-flex
      xs12
    >
      <BaseToolbar
        :title="$t('settings.new_terms')"
        :button-save="true"
        type-title="icon"
        icon="person"
        @save="save"
        @close="close"
      />
      <v-layout
        wrap
        pa-5
        style="overflow-y: auto"
      >
        <v-col
          cols="12"
        >
          <v-row>
            <v-col
              cols="5"
            >
              <v-card
                rounded
              >
                <v-card-title>
                  {{ $t('settings.drawer.content') }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      class="px-5"
                    >
                      <v-switch
                        v-model="term_local.is_default"
                        :disabled="disabledDefault"
                        :label="$t('settings.table.is_default')"
                      ></v-switch>
                    </v-col>
                    <v-col
                      cols="12"
                      class="px-5"
                    >
                      <v-autocomplete
                        outlined
                        :items="countries"
                        v-model="term_local.country_id"
                        item-text="name"
                        item-value="id"
                        :label="$t('settings.table.country')"
                        :data-vv-name="$t('settings.table.country')"
                        :error-messages="errors.collect($t('settings.table.country'))"
                        v-validate="'required'"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="px-5"
                    >
                      <h2>{{ $t('settings.drawer.text') }}</h2>
                      <p
                        class="red--text"
                        v-if="invalid_content"
                      >
                        {{ $t('settings.drawer.required_content') }}
                      </p>
                      <trumbowyg
                        v-model="term_local.content"
                        :config="configTrumbowyg"
                        class="form-control"
                        name="content"
                        :data-vv-name="$t('settings.drawer.text')"
                        :error-messages="errors.collect($t('settings.drawer.text'))"
                        v-validate="'required'"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="7"
            >
              <v-card
                rounded
              >
                <v-card-title>
                  {{ $t('settings.drawer.preview') }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-show="term_local.content">
                  <v-container
                    id="scroll-target"
                    style="max-height: 600px"
                    class="overflow-y-auto"
                  >
                    <v-row
                      v-scroll:#scroll-target="onScroll"
                      style="height: 1000px"
                    >
                      <v-col
                        cols="12"
                      >
                        <div v-html="term_local.content"></div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex"
import BaseToolbar from '@/components/BaseToolbar'

import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'

export default {
  components: {
    BaseToolbar,
    Trumbowyg
  },
  watch: {
    term (newVal, oldVal) {
      if (newVal) {
        this.term_local.is_default = newVal.is_default
        this.term_local.content = newVal.content
        this.term_local.country_id = newVal.country_id
      }
    }
  },
  data () {
    return {
      invalid_content: false,
      term_local: {
        is_default: false,
        content: '',
        country_id: null
      },
      configTrumbowyg: {
        autogrow: false,
        removeformatPasted: true,
        btnsAdd: ['foreColor', 'backColor', 'fontfamily'],
        btns: [
          ['viewHTML'],
          ['undo', 'redo'],
          ['formatting'],
          ['strong', 'em', 'del'],
          ['fontfamily', 'fontsize'],
          ['foreColor', 'backColor', 'superscript', 'subscript'],
          ['link'],
          ['insertImage'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['removeformat']
        ]
      },
    }
  },
  computed: {
    ...mapState({
      countries: ({ countries: { countries } }) => countries,
      terms: ({ terms: { terms } }) => terms,
      term: ({ terms: { term } }) => term
    }),
    disabledDefault () {
      let existDefault = false
      if (this.terms.length > 0) {
        if (this.term && this.term.is_default) {
          existDefault = false
        } else {
          existDefault = !!this.terms.find(t => t.is_default === true)
        }
      }
      return existDefault
    }
  },
  methods: {
    ...mapActions({
      storeTerm: 'terms/storeTerm',
      updateTerm: 'terms/updateTerm',
    }),
    ...mapMutations({
      setTerm: 'terms/setTerm'
    }),
    close () {
      this.term_local = {
        is_default: false,
        content: '',
        country_id: null
      }
      this.$nextTick(() => {
        this.$validator.reset()
      })
      this.setTerm(null)
      this.$emit('close')
    },
    onScroll (e) {},
    async save () {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        this.invalid_content = false
        if (this.term) {
          this.updateTerm({ id: this.term.id, body: this.term_local })
            .then(
              res => {
                this.$noty.success(this.$t('settings.messages.update_success'))
                this.close()
                this.setTerm(null)
              },
              err => {
                this.$noty.error(this.$t('settings.messages.update_error'))
              }
            )
        } else {
          this.storeTerm(this.term_local)
            .then(
              res => {
                this.$noty.success(this.$t('settings.messages.store_success'))
                this.$emit('close')
              },
              err => {
                this.$noty.error(this.$t('settings.messages.store_error'))
              }
            )
        }
      } else {
        if (!this.term.content) {
          this.invalid_content = true
        } else {
          this.invalid_content = false
        }
      }
    }
  }
}
</script>

<style>
</style>